<template>
  <div class="section" :class="$mq">
    <div class="title">{{ $t("step2.inhabitant.title") }}</div>
    <div class="container inline center h-item-margin margin no-legend">
      <div class="frame action content-centered" :class="$mq" @click="decrease()">
        <SvgIcon icon="decrease" class="icon content-centered" fill />
      </div>
      <div class="frame secondary content-centered active">
        <SvgIcon
          v-if="people < 4"
          :icon="`${people}-inhabitant`"
          class="icon inhabitant content-centered"
          fill
          :key="people"
        />
        <SvgIcon v-else icon="4-inhabitant" class="icon inhabitant content-centered" fill />
        <span class="count" :class="$mq" v-if="people < 8">{{ people }}</span>
        <span class="count" :class="$mq" v-if="people > 7">7+</span>
      </div>
      <div class="frame action content-centered" :class="$mq" @click="increase()">
        <SvgIcon icon="increase" class="icon content-centered" fill />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("consumption", ["people"])
  },
  methods: {
    increase() {
      this.$store.commit("consumption/increasePeople");
    },
    decrease() {
      this.$store.commit("consumption/decreasePeople");
    }
  }
};
</script>

<style lang="scss" scoped>
.inhabitant {
  color: #fdcb47;
}
.action {
  .icon {
    color: #7a828c !important;
    padding: 20px;
    width: 50px !important;
    height: 50px !important;
    background: white !important;
  }

  &.mobile {
    .icon {
      border: 0 !important;
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.28);
      border-radius: 50%;
      color: white !important;
      padding: 15px;
      width: 10px !important;
      height: 10px !important;
      background: #7a828c !important;
    }
  }
}

.count {
  cursor: default;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 0.9rem;
  position: absolute;
  margin-top: 30px;
  margin-left: 20px;
  background: #231F20;
  border-radius: 50%;
  color: white;
  width: 25px;
  height: 25px;

  &.mobile {
    font-size: 0.7rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/Inhabitant.vue